export class Campagne {
    constructor(
        public id?: number,
        public libelle?: string,
        public dateOuverture?: any,
        public heureOuverture?: any,
        public dateFermeture?: any,
        public heureFermeture?: any,
        public reinscription?: boolean,
        public ei?: boolean,
        public restrictionEmail?: boolean,
        public restrictionPieces?: boolean,
        public dateCreation?: any,
        public dateModification?: any,
        public dateSuppression?: any,
        public formations?: any[],
        public commissions?: any[]
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/campagne/campagne.model.ts